import { useContext, useState } from "react";
import VisibilityContext from "src/provider/state-manager/visibilityProvider";
import {
  Button,
  CustomContainer,
  FlexRow,
  Form,
  GridContainer,
  PinLabel,
  ScreenTitle,
} from "src/style";
import { SidePopupLayout } from "src/component";
//import {ReactComponent as PinIcon} from 'src/assets/img/tx-pin-icon.svg'
import PinIcon from "src/assets/svg/tx-pin-icon";
import helpers from "src/utils/helpers";
import { handleTypeNumberControl } from "src/utils/utility";
import UserContext from "src/provider/state-manager/userProvider";
import ApiContext from "src/provider/API/call-service";

export const CbpPin: React.FC<any> = ({ onNext, title, onPinChange }) => {
  const { user } = useContext(UserContext);
  const { API } = useContext(ApiContext);
  const [txPin, setTxPin] = useState("");

  const formData = new FormData();
  formData.append("Data.FirstName", user?.onboardingInput?.firstName);
  formData.append("Data.LastName", user?.onboardingInput?.lastName);
  formData.append("Data.MiddleName", user?.onboardingInput?.middleName);
  formData.append("Data.DateOfBirth", user?.onboardingInput?.dateOfBirth);
  formData.append("Data.PhoneNumber", user?.onboardingInput?.phoneNo);
  formData.append("Data.ProfileId", user.userInfo?.profileID);
  formData.append(
    "Data.PrimaryAccountNumber",
    user?.userInfo?.profileInfo?.primaryAccount
  );
  formData.append(
    "Data.Nationality",
    user.userInfo?.profileInfo?.nationality || "NG"
  );
  formData.append(
    "Data.IdType",
    user?.onboardingInput?.identificationType
  );
  formData.append("Data.IdNumber", user?.onboardingInput?.identificationNumber);
  formData.append(
    "Data.Gender",
    user?.onboardingInput?.gender == 0 ? "M" : "F"
  );
  formData.append("Data.Pin", helpers.hashString(txPin));

  const handlePin = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length < 5) {
      setTxPin(e.target.value);
      if (e.target.value.length === 4 && onPinChange)
        onPinChange(helpers.hashString(e.target.value));
    }
  };


  async function handleProceed(
    e: React.FormEvent<HTMLButtonElement | HTMLFormElement>
  ) {
    e.preventDefault();

    const response = await API.createCbpProfile(formData);
    if(response?.isSuccessful === true ){
      onNext()
    }
    
    // if (txPin.length != 4)
    //   return notifier.show("Kindly provide a valid PIN", "Validation Response");
    // if (next) {
    //   await next();
    //   //setTxPin('')
    // }
  }

  return (
    <CustomContainer className="cbp-container">
      {/* <SidePopupLayout close={close}> */}
      <GridContainer topMargin="8">
        <PinIcon />
        <ScreenTitle textSize="2.2" fontWeight="700" topMargin="2.5">
          {title || "Enter PIN"}
        </ScreenTitle>
        <Form onSubmit={handleProceed} topMargin="2.5">
          <GridContainer>
            <FlexRow width="auto" sizeUnit="" gap="1.4">
              <input
                className="display-hidden"
                id="pin"
                name="txPin"
                value={txPin}
                onChange={handlePin}
                onKeyDown={handleTypeNumberControl}
                onKeyUp={handleTypeNumberControl}
                autoFocus={true}
                autoComplete="off"
              />
              <PinLabel
                style={{ paddingTop: "1rem" }}
                className={`${txPin.length === 0 ? "active-pin-box" : ""}`}
                htmlFor="pin"
              >
                {txPin[0] ? "*" : ""}
              </PinLabel>
              <PinLabel
                style={{ paddingTop: "1rem" }}
                className={`${txPin.length === 1 ? "active-pin-box" : ""}`}
                htmlFor="pin"
              >
                {txPin[1] ? "*" : ""}
              </PinLabel>
              <PinLabel
                style={{ paddingTop: "1rem" }}
                className={`${txPin.length === 2 ? "active-pin-box" : ""}`}
                htmlFor="pin"
              >
                {txPin[2] ? "*" : ""}
              </PinLabel>
              <PinLabel
                style={{ paddingTop: "1rem" }}
                className={`${txPin.length >= 3 ? "active-pin-box" : ""}`}
                htmlFor="pin"
              >
                {txPin[3] ? "*" : ""}
              </PinLabel>
            </FlexRow>
          </GridContainer>
          <GridContainer>
            <Button
              width="50"
              height="4"
              topMargin="10"
              borderColor="#0D968F"
              hoverBgColor="#fff"
              hoverColor="#0D968F"
              titleSize="1.4"
              // onClick={onNext}
            >
              Proceed
            </Button>
          </GridContainer>
        </Form>
      </GridContainer>
      {/* </SidePopupLayout> */}
    </CustomContainer>
  );
};
